import { Outlet, useLocation, useNavigate } from "react-router-dom";

import { AgentBubble } from "@/components/agent/AgentBubble";
import { Sidebar } from "@/components/layout/Sidebar";
import { Topbar } from "@/components/layout/Topbar";
import { useAuth } from "@/lib/auth";

const ROUTE_CRUMBS: Record<string, string> = {
  "/dashboard":   "Dashboard",
  "/map":         "Mapa",
  "/mountpoints": "Mountpoints",
  "/clients":     "Clientes",
  "/access":      "Accesos (ACL)",
  "/users":       "Administradores",
};

export function AppLayout() {
  const { logout } = useAuth();
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const handleLogout = async () => {
    await logout();
    navigate("/login", { replace: true });
  };

  const crumbs = ["Caster · Amelia", ROUTE_CRUMBS[pathname] ?? "—"];

  return (
    <div className="app">
      <Sidebar onSignOut={handleLogout} />
      <main className="main carto-grid">
        <Topbar crumbs={crumbs} />
        <Outlet />
      </main>
      <AgentBubble />
    </div>
  );
}
